import React from 'react';
import { Users, Target, Info } from 'lucide-react';

/**
 * Компонент для настройки целевой аудитории
 */
const TargetAudienceSection = ({ 
  formData, 
  handleTargetAudienceChange, 
  errors 
}) => {
  return (
    <div className="mb-6 bg-purple-50 dark:bg-purple-900/20 p-4 rounded-lg border border-purple-200 dark:border-purple-800">
      <h3 className="text-base font-medium text-gray-900 dark:text-white mb-4 flex items-center">
        <Users className="w-5 h-5 mr-2 text-purple-500" />
        Целевая аудитория
      </h3>
      
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {/* Размер целевой аудитории */}
        <div>
          <label htmlFor="audienceSize" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
            Размер целевой аудитории
          </label>
          <input
            type="text"
            id="audienceSize"
            value={formData.targetAudience.size}
            onChange={(e) => handleTargetAudienceChange('size', e.target.value)}
            className={`form-input w-full ${errors.audience_size ? 'input-error' : ''}`}
            placeholder="Количество людей"
          />
          {errors.audience_size && (
            <p className="mt-1 text-xs text-red-500 dark:text-red-400">
              {errors.audience_size}
            </p>
          )}
        </div>

        {/* Планируемый охват */}
        <div>
          <label htmlFor="reachPercent" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
            Планируемый охват (%)
          </label>
          <input
            type="text"
            id="reachPercent"
            value={formData.targetAudience.reachPercent}
            onChange={(e) => handleTargetAudienceChange('reachPercent', e.target.value)}
            className={`form-input w-full ${errors.audience_reachPercent ? 'input-error' : ''}`}
            placeholder="Процент охвата"
          />
          {errors.audience_reachPercent && (
            <p className="mt-1 text-xs text-red-500 dark:text-red-400">
              {errors.audience_reachPercent}
            </p>
          )}
        </div>
      </div>

      {/* Информационная подсказка */}
      <div className="mt-4 flex items-start space-x-3 p-3 bg-purple-100 dark:bg-purple-900/40 rounded-lg border border-purple-200 dark:border-purple-800">
        <Target className="w-5 h-5 text-purple-600 dark:text-purple-400 mt-1 flex-shrink-0" />
        <div>
          <h4 className="text-sm font-medium text-purple-700 dark:text-purple-300 mb-1">
            Как определить целевую аудиторию?
          </h4>
          <p className="text-xs text-purple-600 dark:text-purple-400">
            Размер целевой аудитории - количество потенциальных клиентов, которые могут быть заинтересованы 
            в вашем предложении. Планируемый охват - процент целевой аудитории, который вы рассчитываете 
            достичь вашей рекламной кампанией.
          </p>
        </div>
      </div>
    </div>
  );
};

export default TargetAudienceSection;